var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"p-3"},[_c('div',{staticClass:"d-block credits"},[_c('span',[_vm._v("Copyright 1998-"+_vm._s(_vm.currentYear)+" Divvy Engagement Solutions")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }